<div class="bg-cr-white flex justify-between border-b-[1px] border-zinc-300">
  <div class="flex items-center">
    <img
      class="w-[7.5rem] cursor-pointer pl-4 md:h-[4.25rem] md:w-[9.5rem]"
      [src]="dynamicLogo"
      width="120"
      height="68"
      alt="College Recon"
    />
  </div>
  <div class="flex flex-col">
    <small>Powered by</small>
    <img
      class="mr-4 w-[7.5rem] cursor-pointer md:h-[4.25rem] md:w-[9.5rem]"
      src="/assets/img/logo.1643a230.svg"
      width="100"
      height="58"
      alt="College Recon"
    />
  </div>
</div>
